import { render, staticRenderFns } from "./VacationManagementDetails.vue?vue&type=template&id=61ab453e&scoped=true&"
import script from "./VacationManagementDetails.vue?vue&type=script&lang=js&"
export * from "./VacationManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./VacationManagementDetails.vue?vue&type=style&index=0&id=61ab453e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab453e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VCol,VDialog,VDivider,VRow,VSpacer,VTextarea})
